import { isApiError } from '@/lib/api';

export interface ActiveAppointmentSummary {
  id: string;
  appointmentNumber: number | null;
  status: string;
  startAt: string | null;
}

export interface ActiveAppointmentsErrorBody {
  code: 'ACTIVE_APPOINTMENTS_PRESENT';
  message: string;
  details: {
    activeAppointments: ActiveAppointmentSummary[];
  };
}

function isActiveAppointmentsErrorBody(value: unknown): value is ActiveAppointmentsErrorBody {
  if (!value || typeof value !== 'object') return false;
  const body = value as { code?: unknown; details?: { activeAppointments?: unknown } };
  return (
    body.code === 'ACTIVE_APPOINTMENTS_PRESENT' && Array.isArray(body.details?.activeAppointments)
  );
}

export function isActiveAppointmentsError(error: unknown): error is {
  data: ActiveAppointmentsErrorBody;
} {
  return isApiError(error) && isActiveAppointmentsErrorBody(error.data);
}
